/**
 * Shared motion presets — sourced from `frontend/design/tokens.json`
 * through `./tokens.generated.js`. Values mirror the CSS variables emitted
 * into `styles/css/tokens.generated.css`.
 */

import { DURATION, EASING } from './tokens.generated';

/** Quart-out — smooth deceleration at end of entrances */
export const EASE_ENTRANCE = EASING.entrance;
export const EASE_SMOOTH = EASING.smooth;
export const EASE_EXIT = EASING.exit;

/** Strong custom curves — mirrors the CSS variables in styles/css/base.css */
export const EASE_OUT = EASING.out;
export const EASE_IN_OUT = EASING.inOut;
export const EASE_DRAWER = EASING.drawer;

export const DURATION_PRESS = DURATION.press;
export const DURATION_HOVER = DURATION.hover;
export const DURATION_POPOVER = DURATION.popover;
export const DURATION_EXIT = DURATION.exit;
export const DURATION_MODAL = DURATION.modal;
export const DURATION_FAST = DURATION.fast;
export const DURATION_NORMAL = DURATION.normal;
export const DURATION_SLOW = DURATION.slow;

export const springGentle = { type: 'spring', stiffness: 380, damping: 30 };
export const springSoft = { type: 'spring', stiffness: 260, damping: 28 };

/** Enter/exit pairs — exit is always faster than enter. */
export const enterTransition = { duration: DURATION_POPOVER, ease: EASE_OUT };
export const exitTransition = { duration: DURATION_EXIT, ease: EASE_OUT };
export const drawerTransition = { duration: DURATION_MODAL, ease: EASE_DRAWER };

// Full `transform` strings keep these shared transitions on the compositor
// (Framer's `x`/`y`/`scale` shorthands run through rAF on the main thread).
export const fadeUp = {
  initial: { opacity: 0, transform: 'translateY(12px)' },
  animate: { opacity: 1, transform: 'translateY(0px)' },
  exit: { opacity: 0, transform: 'translateY(-6px)' },
};

export const crossfade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const viewTransition = {
  initial: { opacity: 0, transform: 'translateY(16px) scale(0.995)' },
  animate: { opacity: 1, transform: 'translateY(0px) scale(1)' },
  exit: { opacity: 0, transform: 'translateY(-10px) scale(0.995)' },
};

export const titleSwap = {
  initial: { opacity: 0, transform: 'translateY(10px)' },
  animate: { opacity: 1, transform: 'translateY(0px)' },
  exit: { opacity: 0, transform: 'translateY(-10px)' },
};

export const entranceTransition = {
  duration: DURATION_NORMAL,
  ease: EASE_ENTRANCE,
};
